// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qr_box":"qr_box-1eFqYQQX","qr":"qr-1vu3s3Q9","title":"title-3jS2yDpE","img":"img-1cpS8TrR","tip":"tip-2uaqXtOQ","close":"close-2PpZhJN3"};